import clsx from 'clsx';
import { Check } from 'lucide-react';
import styles from './Checklist.module.scss';

interface ChecklistProps {
  items: string[];
  icon?: React.ReactNode;
  className?: string;
}

export const Checklist: React.FC<ChecklistProps> = ({ items, className, icon }) => (
  <ul className={clsx(styles.list, className)}>
    {items.map((item, index) => (
      <li key={index} className={styles.item}>
        <span className={styles.checkmark} aria-hidden="true">
          {icon || <Check />}
        </span>
        {item}
      </li>
    ))}
  </ul>
);
